module.exports = __webpack_public_path__ + "static/img/bet-records-title.06c7336.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/bet-records-title.png
// module id = i1+i
// module chunks = 1